import { Table, Button } from "antd";
import { setOnViewDevice } from "Components/Report/reportSlice";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { useAppDispatch, useAppSelector } from "store/hook";
import { wan_top } from "Utility/Types/report";
import { useReportTop } from "Components/Report/queries";
import type { ColumnsType } from "antd/lib/table";

const UsageTable = ({ param, id = "", isFetching }: { param: Parameter; id?: string; isFetching: boolean }) => {
  const { title } = useChartParam(param, id);
  const { loginCid, stateCid, level } = useAppSelector((status) => status.global);
  const { filterForm } = useAppSelector((status) => status.report);

  const { data: wanTop } = useReportTop({
    filterForm,
    loginCid,
    stateCid,
    level,
    type: "wan_top",
  });
  const wan = wanTop?.response?.[0]?.wan_top as wan_top[];

  const disp = useAppDispatch();

  const columns: ColumnsType<wan_top> = [
    {
      title: "Location",
      dataIndex: "location",
      ellipsis: true,
    },
    {
      title: "Device",
      dataIndex: "deviceID",
      width: 170,
      render: (_: string, record: any) => (
        <Button type="link" onClick={() => disp(setOnViewDevice(record.id))}>
          {record.name !== "" ? record.name : record.id}
        </Button>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      ellipsis: true,
      responsive: ["xxl"],
    },

    {
      title: "Tx(MB)",
      dataIndex: "tx",
      render: (_: any, record: any) => (record.tx / 1024).toFixed(2),
      sorter: (a, b) => a.tx - b.tx,
    },
    {
      title: "Rx(MB)",
      dataIndex: "rx",
      render: (_: any, record: any) => (record.rx / 1024).toFixed(2),
      sorter: (a, b) => a.rx - b.rx,
    },
    {
      title: "Total(MB)",
      dataIndex: "tx_rx",
      render: (_: any, record: any) => (record.tx_rx / 1024).toFixed(2),
      sorter: (a, b) => a.tx_rx - b.tx_rx,
      defaultSortOrder: "descend",
    },
  ];

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      <Table
        size="middle"
        columns={columns}
        dataSource={wan}
        pagination={{ pageSize: 5, size: "small", showSizeChanger: false, showQuickJumper: true }}
        rowKey={(record) => record.id}
      />
    </ChartCard>
  );
};

export default UsageTable;
